import {
    CURB_LINKS_RECEIVED,
    GET_CURB_LINKS,
    POST_FEEDBACK_DATA,
    POST_SEGMENT_FEEDBACK_DATA,
    SET_LAT_LNG,
    SET_MAP_OBJECT,
    SET_MARKERS,
    STORE_GEOSERVER_DATA,
    TOGGLE_DISTANCE_TOOL,
    TOGGLE_MAP,
    IS_POINTER_EVENTS_ENABLED,
    SetMapObject,
    SetMarkers,
    GetCurbLinks,
    CurbLinksReceived,
    SetLatLng,
    ToggleMap,
    ToggleDistanceTool,
    StoreGeoserverData,
    PostFeedbackData,
    IsPointerEventsEnabled,
    SET_HIGHLIGHTED_MAPLAYERS_DATA,
    SetHighlightedMapLayersData,
    PostSegmentFeedbackData
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const setMapObject = createAction<SetMapObject["payload"]>(SET_MAP_OBJECT);

export const setMarkers = createAction<SetMarkers["payload"]>(SET_MARKERS);

export const getCurbLinks = createAction<GetCurbLinks["payload"]>(GET_CURB_LINKS);

export const curbLinksReceived = createAction<CurbLinksReceived["payload"]>(CURB_LINKS_RECEIVED);

export const setLatLng = createAction<SetLatLng["payload"]>(SET_LAT_LNG);

export const toggleMap = createAction<ToggleMap["payload"]>(TOGGLE_MAP);

export const toggleDistanceTool = createAction<ToggleDistanceTool["payload"]>(TOGGLE_DISTANCE_TOOL);

export const storeGeoserverData = createAction<StoreGeoserverData["payload"]>(STORE_GEOSERVER_DATA);

export const postFeedbackData = createAction<PostFeedbackData["payload"]>(POST_FEEDBACK_DATA);

export const postSegmentFeedbackData = createAction<PostSegmentFeedbackData["payload"]>(
    POST_SEGMENT_FEEDBACK_DATA
);

export const isPointerEventsEnabled =
    createAction<IsPointerEventsEnabled["payload"]>(IS_POINTER_EVENTS_ENABLED);

export const setHighlightedMapLayersData = createAction<SetHighlightedMapLayersData["payload"]>(
    SET_HIGHLIGHTED_MAPLAYERS_DATA
);
